import React, { useEffect, useState } from 'react';
import "../../assets/styles/Search.css";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { apiCheckAccount, apiGetSetting } from "../../services/api.service.js";

function SearchUser() {
  const [userName, setUserName] = useState("");
  const [webSetting, setWebSetting] = useState("");
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiGetSetting();
        if (result && result.status_code === 200 && result.data) {
          setWebSetting(result.data);
        }
      } catch (error) {
        return Swal.fire({ icon: "error", text: "Lỗi kết nối, vui lòng liên hệ CSKH để được hỗ trợ." });
      }
    };
    fetchData();
  }, []);

  const checkUser = async () => {
      if (!userName) {
        return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
      } else {
        let result = await apiCheckAccount(userName);
        if (result && result?.code === 200) {
          let data = result.data;
          navigate("/profile",{ state: { userName, data, webSetting } });
        }
      }
  };

  return (
    <div className="container">
      <div className="app">
        <Header isPageSearch={true} />
        <div className="content">
          <div className="search-user">
            <span className="item-in-search">VUI LÒNG XÁC NHẬN TÀI KHOẢN CỦA BẠN</span>
            <div className="item-in-search input-search">
              {/* <img className="icon-search" alt="icon-search" src={iconSearch} /> */}
              <input className="input-account"
                onChange={(e) => setUserName(e.target.value.toLowerCase().trim())}
                type="text"
                placeholder="Nhập tên đăng nhập"
              />
              <button className="btn-search-account" onClick={checkUser}>KIỂM TRA</button>
            </div>
            <p className="item-in-search text-link-home">Liên kết chính thức:&nbsp;
              <a href={ webSetting.link_home }
                target="_blank"
                rel="noopener noreferrer">{webSetting.link_home}
              </a>
            </p>
            <div className="description">
              {webSetting && webSetting.login_info_notice ? (
                <div dangerouslySetInnerHTML={{ __html: webSetting.login_info_notice }} />
              ) : null}
            </div>
            {/* <div>
              <img className="img-bottom" alt="bottom" src={imgBottom} />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchUser;
